<div class="integration-status">
  <h3>{{ 'INTEGRATION.SYNCHRONIZING' | translate }}</h3>
  <ul>
    @for (system of systems(); track system.name) {
      <li>
        <span>{{ system.name }}</span>

        @if (system.status === 'completed') {
          <mat-icon class="status-success">check_circle</mat-icon>
        } @else if (system.status === 'failed') {
          <mat-icon class="status-error">error</mat-icon>
        } @else if (system.status === 'in-progress') {
          <mat-icon class="spinning">sync</mat-icon>
        } @else if (system.status === 'pending') {
          <span class="pending">{{ system.statusText }}</span>
        }
      </li>
    }
  </ul>
</div>
